import { render, staticRenderFns } from "./RestrictAnnounceScreen.vue?vue&type=template&id=2ed0fc70&scoped=true"
import script from "./RestrictAnnounceScreen.vue?vue&type=script&lang=js"
export * from "./RestrictAnnounceScreen.vue?vue&type=script&lang=js"
import style0 from "./RestrictAnnounceScreen.vue?vue&type=style&index=0&id=2ed0fc70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed0fc70",
  null
  
)

export default component.exports